import React, { useEffect } from 'react';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const existing = document.getElementById('termly-jssdk');
    if (!existing) {
      const js = document.createElement('script');
      js.id = 'termly-jssdk';
      js.src = 'https://app.termly.io/embed-policy.min.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(js, firstScript);
    }
  }, []);

  return (
    <div className="section bg-gray-50">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <div className="card">
            <div name="termly-embed" data-id="30c5d3c2-cc5e-4cbd-be7c-fab3d50075c0"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
